import { v4 as uuidv4 } from "uuid";
import type { FeedMappingRecord } from "../types";

export type FeedMappingPersistPayload = {
  feedEntityId: unknown;
  feedType: unknown;
  status: unknown;
  id?: unknown;
};

export function validateFeedMappingItems(rows: FeedMappingRecord[]): boolean {
  return rows.every((row) => row.feedEntityId && row.feedType && row.status);
}

export function formatFeedMappingForPersist(row: FeedMappingRecord): FeedMappingPersistPayload {
  const payload: FeedMappingPersistPayload = {
    feedEntityId: row.feedEntityId,
    feedType: row.feedType,
    status: row.status,
  };
  // `uniqueId` / client `id` are for grid identity only — omit for newly added rows.
  if (row.id != null && !row.newlyAdded) {
    payload.id = row.id;
  }
  return payload;
}

export function createFeedMappingRow(): FeedMappingRecord {
  return {
    feedEntityId: "",
    feedType: null,
    status: 1,
    source: "",
    newlyAdded: true,
    uniqueId: uuidv4(),
  };
}
